import React, { Component } from 'react'
import classNames from 'classnames';
import { LOCAL_STORAGE, USER_TYPES } from '../../../constants';
import { AccountForm } from '../../ui/Forms/Profile/AccountForm';
import { InformationForm } from '../../ui/Forms/Profile/InformationForm';
import { ChangePasswordForm } from '../../ui/Forms/Profile/ChangePasswordForm';
import { PaymentsForm } from '../../ui/Forms/Profile/PaymentsForm';

const TABS = ['account', 'info', 'password'];
// const TABS = ['account', 'info', 'password', 'payments'];

class Profile extends Component {

  tabs = {
    0: AccountForm,
    1: InformationForm,
    2: ChangePasswordForm,
    // 3: PaymentsForm,
  };

  states = {
    0: 'account',
    1: 'information',
    2: 'password',
    // 3: 'payments'
  }

  constructor(props) {
    super(props);

    const activeTabIndex = 1;
    const unparsedUser = localStorage.getItem(LOCAL_STORAGE.USER);
    const user = JSON.parse(unparsedUser);
    const currentUser = this.props.currentUser ? {
      ...this.props.currentUser,
      user_type: user.user_type,
    } : user;

    this.state = {
      activeTabIndex,
      formName: this.states[activeTabIndex],
      account: {
        state: { ...this.collectDataForForm(currentUser|| {}, 0) },
        errors: {}
      },
      information: {
        state: { ...this.collectDataForForm(currentUser|| {}, 1) },
        errors: {}
      },
      password: {
        state: { ...this.collectDataForForm(currentUser || {}, 2) },
        errors: {}
      },
      payments: {
        state: { ...this.collectDataForForm(currentUser || {}, 2) },
        errors: {}
      }
    }
  }

  componentDidMount() {
    const {currentUserActions, getSubscriptions, history} = this.props;
    currentUserActions.getCurrentUser();
    getSubscriptions();
    if(history.location.state && history.location.state.tab)
      this.setState({activeTabIndex: history.location.state.tab});
  }

  componentDidUpdate(prevProps) {
    const { currentUser, message } = this.props;
    const unparsedUser = localStorage.getItem(LOCAL_STORAGE.USER);
    const user = JSON.parse(unparsedUser);
    const currentUserUpdated = currentUser ? {
      ...currentUser,
      user_type: user ? user.user_type : '',
    } : user;

    if (currentUser !== prevProps.currentUser) {
      this.collectAllData(currentUserUpdated);
    }

    if(message !== prevProps.message) {
      this.timeout = setTimeout(this.clearMessage, 3000);
    }
  }

  clearMessage = () => {
    const { currentUserActions } = this.props;

    currentUserActions.updateCurrentUserSuccess();
  }

  onSubmit = (e) => {
    e.preventDefault();
    const { activeTabIndex } = this.state;
    const errors = this._validate();

    if (errors) {
      return this._addErrorsForCurrentForm(errors);
    } else {
      this._addErrorsForCurrentForm({});
    }

    if(this.states[activeTabIndex] !== this.states[2])
      this.props.currentUserActions.updateCurrentUser(this._currentState())
    else
      this.props.authActions.changePassword(this._currentState());
  }

  onChangeTab = activeTabIndex => {
    this.clearMessage();
    this.setState(
      { activeTabIndex, formName: this.states[activeTabIndex], }
    );
  }

  onChangeForm = ({ name, value }, e) => {
    const { formName } = this.state;
    this.setState({
      [formName]: {
        ...this.state[formName],
        state: {
          ...this.state[formName].state,
          [name]: value,
          errors: {}
        }
      }
    });
  }

  inputProps = (name) => {
    const { formName } = this.state;
    const form = this.state[formName];
    let error = form.errors[name] ? form.errors[name].join(' ') : null;

    const frontendErrors = this._currentErrors();
    const backendErrors = this.props.updateErrors;

    if (!backendErrors) {
      error = frontendErrors[name];
    } else {
      error = backendErrors[name];
    }

    return {
      name,
      error,
      onChange: this.onChangeForm,
      value: name === 'user_type' ? form.state[name] : form.state[name],
      classes: { wrapper: 'p-form-item', error: 'error-text' }
    }
  }

  CurrentTab = () => {
    const {createPayment} = this.props;
    const unparsedUser = localStorage.getItem(LOCAL_STORAGE.USER);
    const user = JSON.parse(unparsedUser);
    const { activeTabIndex } = this.state;
    const Tab = this.tabs[activeTabIndex];

    if (!Tab) {
      return null;
    }
    const currentState = this._currentState();
    const frontendErrors = this._currentErrors();
    const backendErrors = this.props.updateErrors;
    const passwordError = this.props.changePasswordErrors;
    const subscriptions = this.props.subscriptions;
    let errors;

    if (!backendErrors) {
      errors = frontendErrors;
    } else {
      errors = backendErrors;
    }

    return <Tab
      inputProps={this.inputProps}
      onSubmit={this.onSubmit}
      formData={currentState}
      currentUser={this.props.currentUser}
      errors={errors}
      onChange={this.onChangeForm}
      message={this.props.message || this.props.successPasswordMessage}
      user={user}
      passwordError={ passwordError }
      subscriptions={subscriptions}
      createPayment={createPayment}
    />;
  }

  collectDataForForm = (dataToScrap, activeTabIndex) => {
    const Tab = this.tabs[activeTabIndex];

    return Tab.fields.reduce((acc, field) => {
      return { ...acc, [field]: dataToScrap[field] }
    }, {})
  }

  collectAllData = (dataToScrap) => {
    const dataToChange = { ...this.state };
    Object.keys(this.states).forEach((stateIndex) => {
      dataToChange[this.states[stateIndex]].state = {
        ...dataToChange[this.states[stateIndex]].state,
        ...this.collectDataForForm(dataToScrap, stateIndex)
      }
    });

    this.setState({
      dataToChange
    });
  }

  _validate() {
    const { activeTabIndex, formName } = this.state;
    const Tab = this.tabs[activeTabIndex];
    const { state } = this.state[formName];
    return Tab.validate(state);
  }

  _addErrorsForCurrentForm(errors) {
    const { formName } = this.state;
    this.setState({
      [formName]: {
        ...this.state[formName],
        errors: errors || {}
      }
    });
  }

  _renderTabs = () => {
    const { activeTabIndex } = this.state;

    return TABS.map((tab, index) => (
      <div
        key={ index }
        onClick={() => this.onChangeTab(index)}
        className={classNames("tab-btn",  { active: activeTabIndex === index } )}
      >
        {tab}
      </div>
    ))
  }

  _currentState = () => this.state[this.state.formName].state;
  _currentErrors = () => this.state[this.state.formName].errors;

  componentWillUnmount() {
    this.clearMessage();
    clearTimeout(this.timeout);
  }

  render() {
    const {activeTabIndex} = this.state;
    return (
      <main>
        <section className="sec-profile">
          <div className="container">
            <div className="heading">
              <p>my profile</p>
            </div>
            <div className=" profile-container">
              <div className="profile--tabs-btn">
                {this._renderTabs()}
              </div>
              <div className="profile--tabs-container" style={activeTabIndex === 3 ? {maxWidth: 'none'} : {}}>
                <this.CurrentTab />
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default Profile;
